module.exports = __webpack_public_path__ + "img/ancient_apparition.b7c77ead.png";